export default function mixin(a, b, options = {}) {
  const ignoredProps = options.ignoredProps || [];
  Object.getOwnPropertyNames(b).forEach(propName => {
    if (ignoredProps.includes(propName)) return;
    const propDescriptor = Object.getOwnPropertyDescriptor(b, propName);
    Object.defineProperty(a, propName, propDescriptor);
  });
}
